import styled from "styled-components";

// Main container with responsive design
export const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 8px;

  @media (min-width: 768px) {
    padding: 32px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 12px;
    margin-bottom: 24px;
  }
`;

export const SearchAndActionBar = styled.div`
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0;
  }
`;

// Filter section
export const FilterSection = styled.div`
  width: 100%;
  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #E2E2E2;
  padding: 24px 24px 8px 24px;
  box-sizing: border-box;
  border-radius: 6px;

  @media (max-width: 767px) {
    padding: 16px;
  }
`;

export const DesktopFilterSection = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const MobileFilterSection = styled.div`
  display: block;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (min-width: 1024px) {
    gap: 20px;
    margin-bottom: 20px;
    max-width: 600px;
  }
`;

export const FilterLabel = styled.div`
  font-size: 14px;
  font-weight: 500;

  @media (min-width: 1024px) {
    font-size: 16px;
  }
`;

// Order Status Tabs - Enhanced styling based on reference
export const TabsContainer = styled.div`
  border-bottom: 1px solid #e2e8f0;
`;

export const TabsList = styled.div`
  display: flex;
  gap: 0;
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  padding: 16px 24px;
  border: none;
  background: none;
  font-size: 16px;
  font-weight: 600;
  color: ${(props) => (props.$isActive ? "#e39435" : "#1E2F23")};
  cursor: pointer;
  border-bottom: 2px solid
    ${(props) => (props.$isActive ? "#e39435" : "transparent")};
  transition: all 0.2s;

  &:hover {
    color: #e39435;
    background: #fef5e7;
  }

  @media (max-width: 767px) {
    padding: 12px 16px;
    font-size: 14px;
  }
`;

export const DatePickerWrapper = styled.div`
  width: 100%;
input{
      width: 100%;
    }
  @media (min-width: 768px) {
    width: 100%;
    max-width:180px;
  }
`;

export const SearchButton = styled.button`
  display: flex;
  align-items: center;
  padding: 10px 20px;
  background: #e39435;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;

  svg {
    width: 16px;
    height: 16px;
  }

  @media (min-width: 768px) {
    padding: 12px 24px;
    font-size: 16px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

// Desktop SearchButton with specific styling
export const DesktopSearchButton = styled(SearchButton)`
  height: 40px;
  min-height: 40px;
  padding: 0 20px;
  justify-content: center;
  margin-top: 24px;
  gap: 8px;
`;

export const DesktopSearchButtonWallet = styled(SearchButton)`
  height: 40px;
  justify-content: center;
  gap: 8px;
  padding: 8px 16px;
max-width:150px;
margin-top:8px;

@media (min-width: 1024px) {
  margin-top:24px;
}

@media (min-width: 768px) and (max-width: 1023px) {
  margin-top:20px;
}
`;

// Mobile SearchButton with full width
export const MobileSearchButton = styled(SearchButton)`
  width: 100%;
  margin-top: 8px;
  height: 40px;
  min-height: 40px;
  padding: 0 20px;
  justify-content: center;
  gap: 8px;
`;

// Table section with enhanced mobile design
export const TableContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;

// Enhanced empty state
export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 80px 40px;
  }
`;

export const EmptyStateText = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const OrderCount = styled.span`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const AdvanceSearchButton = styled.button`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #76b041;
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  gap: 8px;
  height: 38px;
  width: 180px;

  svg {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 768px) {
    padding: 14px 20px;
    font-size: 16px;
    height: 48px;
    border-radius: 24px;
  }
`;

export const Divider = styled.div`
  height: 1px;
  background: #e5e7eb;
  margin: 20px 0;

  @media (min-width: 768px) {
    margin: 24px 0;
  }
`;

// Enhanced CollapsibleTable styled components
export const CustomTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
`;

export const CustomTableHead = styled.thead`
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
`;

export const CustomTableBody = styled.tbody`
  background: white;
`;

export const CustomTableRow = styled.tr`
  border-bottom: 1px solid #f1f5f9;
  transition: background-color 0.2s ease;

  &:hover {
    background: #fafbfc;
  }

  &:last-child {
    border-bottom: none;
  }
`;

export const CustomTableHeader = styled.th`
  padding: 16px 12px;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  background: #f8fafc;

  @media (min-width: 768px) {
    padding: 20px 16px;
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    padding: 24px 20px;
  }
`;

export const CustomTableCell = styled.td`
  padding: 12px;
  font-size: 14px;
  color: #374151;
  vertical-align: middle;

  @media (min-width: 768px) {
    padding: 16px;
    font-size: 16px;
  }

  @media (min-width: 1024px) {
    padding: 16px;
  }
`;

export const TableCellStyle = styled(CustomTableCell)`
  padding: 12px;
  font-size: 14px;
  color: #374151;
  vertical-align: middle;
  text-align: center;
`;

export const CartMenuImage = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 12px;
  border: 1px solid #e5e7eb;

  @media (min-width: 768px) {
    width: 56px;
    height: 56px;
    margin-right: 16px;
  }

  @media (min-width: 1024px) {
    width: 64px;
    height: 64px;
  }
`;

export const ItemName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 4px;
  line-height: 1.4;

  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

export const ItemIngredient = styled.div`
  font-size: 12px;
  color: #6b7280;
  line-height: 1.3;

  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media (min-width: 768px) {
    gap: 12px;
  }
`;

export const QuantityInput = styled.input`
  width: 60px;
  padding: 8px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  background: white;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #e39435;
    box-shadow: 0 0 0 3px rgba(227, 148, 53, 0.1);
  }

  @media (min-width: 768px) {
    width: 70px;
    padding: 10px 14px;
    font-size: 16px;
  }
`;

export const NoDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: white;
  border-radius: 12px;
  text-align: center;

  @media (min-width: 768px) {
    padding: 80px 40px;
  }
`;

export const NoDataText = styled.p`
  font-size: 16px;
  color: #6b7280;
  margin: 0;
  font-weight: 500;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

// Action buttons
export const ActionButton = styled.button<{
  $variant?: "primary" | "secondary" | "danger";
}>`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) => {
    switch (props.$variant) {
      case "primary":
        return `
          background: #e39435;
          color: white;
          &:hover { background: #d4822a; }
        `;
      case "danger":
        return `
          background: #ef4444;
          color: white;
          &:hover { background: #dc2626; }
        `;
      default:
        return `
          background: #f3f4f6;
          color: #374151;
          &:hover { background: #e5e7eb; }
        `;
    }
  }}

  @media (min-width: 768px) {
    padding: 10px 20px;
    font-size: 16px;
  }
`;

export const ModalButton = styled.button<{
  $variant?: "primary" | "secondary";
}>`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) =>
    props.$variant === "primary"
      ? `
    background: #e39435;
    color: white;
    &:hover { background: #d4822a; }
  `
      : `
    background: #f3f4f6;
    color: #374151;
    &:hover { background: #e5e7eb; }
  `}
`;

export const OrderStatus = styled.div<{ $status?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;

  ${(props) => {
    switch (props.$status) {
      case "completed":
      case "d":
        return `
          background: #dcfce7;
          color: #166534;
        `;
      case "pending":
      case "p":
        return `
          background: #fef3c7;
          color: #92400e;
        `;
      case "rejected":
      case "r":
        return `
          background: #fee2e2;
          color: #991b1b;
        `;
      default:
        return `
          background: #e5e7eb;
          color: #374151;
        `;
    }
  }}

  @media (min-width: 768px) {
    font-size: 13px;
    padding: 8px 16px;
  }
`;

export const ReportOrderStatus = styled.div<{ $status?: string }>`
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;

  ${(props) => {
    switch (props.$status) {
      case "Available":
      case "a":
        return `
          background: #76B041;
          color: #FFFFFF;
        `;
      case "u":
      case "Unavailable":
        return `
          background: #D44B1F;
          color: #FFFFFF;
        `;
      case "Deleted":
      case "d":
        return `
          background: #E1E1E1;
          color: #A5A5A5;
        `;
      default:
        return `
          background: #76B041;
          color: #FFFFFF;
        `;
    }
  }}

  @media (min-width: 768px) {
    font-size: 13px;
    padding: 8px 16px;
  }
`;

// Mobile and Tablet Card Layout Components
export const OrderCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;

  @media (min-width: 768px) {
    gap: 20px;
  }

  @media (min-width: 1024px) {
    display: none; // Hide cards on desktop, show table instead
  }
`;

export const OrderCard = styled.div`
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    transform: translateY(-1px);
  }

  @media (min-width: 768px) {
    padding: 20px;
    border-radius: 16px;
  }
`;

export const OrderCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  gap: 12px;
`;

export const OrderNumber = styled.div<{ $activeTab?: string }>`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 16px;
  display: flex;
  color: ${(props) => (props.$activeTab === "history" ? "#1E2F23" : "#E39435")};

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

export const OrderTime = styled.div<{ $activeTab?: string }>`
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const OrderCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const OrderInfoRow = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 0px 8px 0px;
`;

export const OrderInfoLabel = styled.span`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const OrderInfoValue = styled.span`
  font-size: 14px;
  color: #1f2937;
  font-weight: 400;
  text-align: right;
  display: flex;
  align-items: center;
`;

export const DeliveryBuddy = styled.div<{ $activeTab?: string }>`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #374151;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

export const OrderPrice = styled.div<{ $activeTab?: string }>`
  font-size: 14px;
  font-weight: 400;
  color: #1f2937;
`;

// Desktop Table Container (only visible on desktop)
export const DesktopTableContainer = styled.div`
  display: none;
  border : 0.5px solid #E2E2E2;
  border-radius: 8px;

  @media (min-width: 1024px) {
    display: block;
  }
`;

// Arrow right icon for view details button
export const ArrowRightIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236b7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M9 5l7 7-7 7'/%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 24px;
    height: 24px;
  }
`;

export const TableCellText = styled.span`
  font-size: 16px;
  color: #313131;
`;

export const OrderNumberText = styled(ItemName)`
  margin-bottom: 0;
`;

export const ClickableTableRow = styled(CustomTableRow)`
  cursor: pointer;
`;

export const MinWidthTableCell = styled(CustomTableCell)<{ $minWidth?: string }>`
  min-width: ${props => props.$minWidth || 'auto'};
`;

// Card detail text components
export const CardDetailText = styled.span`
  font-size: 16px;
  color: #E39435;
  font-weight: 600;
`;

export const CardInfoText = styled.span`
  font-size: 16px;
  color: #374151;
  font-weight: 600;
`;
